import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { IFormData } from '../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import { IRepeteraAktivitetValues } from './RepeteraAktivitetFormStep2';

export const getCheckedValues = (values: IRepeteraAktivitetValues) => {
  const checkedValues = [
    { day: 'måndag', value: values.mondayChecked },
    { day: 'tisdag', value: values.tuesdayChecked },
    { day: 'onsdag', value: values.wednesdayChecked },
    { day: 'torsdag', value: values.thursdayChecked },
    { day: 'fredag', value: values.fridayChecked },
    { day: 'lördag', value: values.saturdayChecked },
    { day: 'söndag', value: values.sundayChecked },
  ];
  return checkedValues;
};

export const getInitalRows = (
  values: IRepeteraAktivitetValues,
  aktivitet: IFormData
) => {
  let checkedValues = getCheckedValues(values);

  const getDatesBetween = (startDate: any, endDate: any) => {
    const dates = [];
    while (startDate <= endDate) {
      dates.push(new Date(startDate));
      startDate.setDate(startDate.getDate() + 1);
    }
    return dates;
  };

  const date1 = new Date(values.datumFr);
  const date2 = new Date(values.datumTi);

  let allDates = getDatesBetween(date1, date2);

  let rows: GridValidRowModel[] = [];
  let number = 1;

  allDates.map(item => {
    let id = number++;
    let convertToSwedishDayName = item.toLocaleString('sv-SE', {
      weekday: 'long',
    });
    rows.push({
      id: id,
      Vald: true,
      Titel: aktivitet.TITEL,
      Datum: item.toLocaleDateString(),
      Dag: convertToSwedishDayName,
      Tid: `${aktivitet.FRANTID} - ${aktivitet.TILLTID}`,
      Plats: aktivitet._Associations?.AktBokRubrik?.[0].RESURS_NAMN,
    });
  });
  rows = rows.filter(item =>
    checkedValues.some(
      checkedValue => checkedValue.day === item.Dag && checkedValue.value
    )
  );
  return rows;
};
